module.exports = __webpack_public_path__ + "static/media/home.d626d6a7.png";